import React from 'react';

export default function Hero({ onDemo }) {
  return (
    <section style={{ position: 'relative', overflow: 'hidden', background: '#060606', padding: '7rem 2.5rem 6rem' }}>

      {/* Background glow */}
      <div style={{ position: 'absolute', top: -200, left: '30%', transform: 'translateX(-50%)', width: 700, height: 600, background: 'radial-gradient(ellipse, rgba(10,158,143,0.12) 0%, transparent 70%)', pointerEvents: 'none', zIndex: 0 }} />

      {/* Subtle grid */}
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(10,158,143,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(10,158,143,0.03) 1px, transparent 1px)', backgroundSize: '60px 60px', maskImage: 'radial-gradient(ellipse 70% 60% at 30% 0%, black 0%, transparent 100%)', pointerEvents: 'none', zIndex: 0 }} />

      {/* Two-column layout */}
      <div className="hero-grid" style={{ position: 'relative', zIndex: 1, maxWidth: 1160, margin: '0 auto' }}>

        {/* LEFT — Text */}
        <div style={{ textAlign: 'left' }}>

          {/* Badge */}
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(10,158,143,0.08)', border: '1px solid rgba(10,158,143,0.2)', color: '#0a9e8f', fontSize: '0.65rem', fontWeight: 500, padding: '6px 16px', borderRadius: 100, marginBottom: '2rem', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em' }}>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#0a9e8f', display: 'inline-block', animation: 'pulse 2s infinite' }} />
            ENTERPRISE DIALLER INTELLIGENCE
          </div>

          {/* Headline */}
          <h1 style={{ fontSize: 'clamp(2.6rem, 4.5vw, 4.2rem)', fontWeight: 700, lineHeight: 1.05, letterSpacing: '-0.045em', marginBottom: '1.5rem', color: '#f0f0f0' }}>
            Dial smarter.<br />
            <span style={{ color: '#0a9e8f' }}>Connect more.</span><br />
            Close faster.
          </h1>

          {/* Subtext */}
          <p style={{ fontSize: '1rem', color: '#909090', maxWidth: 400, fontWeight: 300, lineHeight: 1.85, letterSpacing: '-0.01em', marginBottom: '2.5rem' }}>
            Outbound & inbound communications built for high-volume contact teams. Intelligent dialling, CLI rotation, omnichannel — one platform.
          </p>

          {/* CTA */}
          <button onClick={onDemo} style={{ background: '#0a9e8f', color: '#060606', padding: '0.9rem 2.2rem', borderRadius: 8, fontSize: '0.9375rem', fontWeight: 700, border: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8, transition: 'all .2s', letterSpacing: '-0.01em' }}
            onMouseEnter={e => { e.currentTarget.style.background = '#0db8a7'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(10,158,143,0.3)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#0a9e8f'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
            Request a demo <ArrowIcon />
          </button>
        </div>

        {/* RIGHT — Mac browser window */}
        <div style={{ position: 'relative' }}>

          {/* Glow behind the window */}
          <div style={{ position: 'absolute', top: '15%', left: '10%', right: '10%', bottom: '0%', background: 'radial-gradient(ellipse, rgba(10,158,143,0.18) 0%, transparent 70%)', pointerEvents: 'none', zIndex: 0 }} />

          {/* Browser window */}
          <div style={{
            position: 'relative',
            zIndex: 1,
            transformOrigin: 'center center',
            animation: 'browserTilt 8s ease-in-out infinite',
            borderRadius: 12,
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: '0 32px 80px rgba(0,0,0,0.75), 0 0 0 1px rgba(10,158,143,0.15), 20px 20px 60px rgba(0,0,0,0.5)',
          }}>

            {/* Mac titlebar */}
            <div style={{ background: 'linear-gradient(to bottom, #323232, #282828)', padding: '9px 14px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid #1a1a1a' }}>
              {/* Traffic lights */}
              <div style={{ display: 'flex', gap: 6, marginRight: 12, flexShrink: 0 }}>
                <span style={{ width: 11, height: 11, borderRadius: '50%', background: '#ff5f57', display: 'inline-block', boxShadow: 'inset 0 0 0 0.5px rgba(0,0,0,0.3)' }} />
                <span style={{ width: 11, height: 11, borderRadius: '50%', background: '#febc2e', display: 'inline-block', boxShadow: 'inset 0 0 0 0.5px rgba(0,0,0,0.3)' }} />
                <span style={{ width: 11, height: 11, borderRadius: '50%', background: '#28c840', display: 'inline-block', boxShadow: 'inset 0 0 0 0.5px rgba(0,0,0,0.3)' }} />
              </div>
              {/* Address bar */}
              <div style={{ flex: 1, background: '#1e1e1e', borderRadius: 5, padding: '3px 10px', display: 'flex', alignItems: 'center', gap: 5, maxWidth: 280, margin: '0 auto' }}>
                <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#4a4a4a" strokeWidth="2.5" style={{ flexShrink: 0 }}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                <span style={{ fontSize: '0.6rem', color: '#555', fontFamily: 'system-ui, sans-serif', whiteSpace: 'nowrap' }}>dialler.dialspark.ai</span>
              </div>
            </div>

            {/* Screenshot — show top 65% only, fade bottom */}
            <div style={{ position: 'relative', lineHeight: 0, maxHeight: 380, overflow: 'hidden' }}>
              <img
                src="/dashboard.png"
                alt="DIALSPARK platform"
                style={{ width: '100%', display: 'block', objectFit: 'cover', objectPosition: 'top' }}
              />
              {/* Bottom fade */}
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '50%', background: 'linear-gradient(to bottom, transparent, rgba(6,6,6,0.95))', pointerEvents: 'none' }} />
            </div>
          </div>
        </div>

      </div>

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
        @keyframes browserTilt {
          0%   { transform: perspective(1000px) rotateY(-6deg) rotateX(3deg); }
          50%  { transform: perspective(1000px) rotateY(4deg)  rotateX(1deg); }
          100% { transform: perspective(1000px) rotateY(-6deg) rotateX(3deg); }
        }
      `}</style>
    </section>
  );
}

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);
